/* @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Dialog, Grid, Typography2 } from '@coursera/cds-core';

import { CoachButton } from 'bundles/ai-coach-platform/components/building-blocks';
import { getFeatureNameLabels } from 'bundles/ai-coach-platform/utils/brandLabels';

import _t from 'i18n!nls/ai-coach-platform';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => void;
};

export const DeleteAllMemoryModal = ({ isOpen, onClose, onSubmit }: Props): React.ReactElement => {
  const { Content, Actions, HeadingGroup } = Dialog;
  const { featureNameLabel } = getFeatureNameLabels();

  const handleOnSubmit = () => {
    onSubmit();
    onClose();
  };

  const handleOnClose = () => {
    onClose();
  };

  return (
    <Dialog variant="transactional" aria-describedby="dialog-content" open={isOpen} onClose={handleOnClose}>
      <HeadingGroup>{_t('Delete all memory')}</HeadingGroup>
      <Content id="dialog-content">
        <Typography2
          variant="bodyPrimary"
          component="p"
          css={css`
            color: var(--cds-color-grey-800);
          `}
        >
          {_t('#{featureNameLabel} will forget all memories from your past conversations.', { featureNameLabel })}
        </Typography2>
      </Content>
      <Actions>
        <Grid container spacing={16}>
          <Grid item>
            <CoachButton variant="primary" onClick={handleOnSubmit}>
              {_t('Confirm deletion')}
            </CoachButton>
          </Grid>
          <Grid item>
            <CoachButton variant="secondary" onClick={handleOnClose}>
              {_t('Cancel')}
            </CoachButton>
          </Grid>
        </Grid>
      </Actions>
    </Dialog>
  );
};

export default DeleteAllMemoryModal;
